export default "__VITE_ASSET__DTSRx2$E__"